import apiCompat from '../api-compat.json';
import { apiUrl } from './api';

export type ApiCompatConfig = {
  requiredBackendVersion: string;
  forceMatch: boolean;
};

export type ApiCompatStatus =
  | { kind: 'ok'; required: string; live: string }
  | { kind: 'mismatch'; required: string; live: string; forceMatch: boolean }
  | { kind: 'unreachable'; required: string; forceMatch: boolean };

export const API_COMPAT: ApiCompatConfig = {
  requiredBackendVersion: apiCompat.requiredBackendVersion,
  forceMatch: Boolean(apiCompat.forceMatch),
};

const DISMISS_KEY = 'api_compat_soft_dismiss';

export function versionsCoincide(required: string, live: string): boolean {
  return required.trim() === live.trim();
}

export async function fetchLiveBackendVersion(): Promise<string | null> {
  try {
    const res = await fetch(apiUrl('/api/version'), {
      method: 'GET',
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { version?: string };
    return typeof data.version === 'string' ? data.version : null;
  } catch {
    return null;
  }
}

export async function checkApiCompat(): Promise<ApiCompatStatus> {
  const required = API_COMPAT.requiredBackendVersion;
  const forceMatch = API_COMPAT.forceMatch;
  const live = await fetchLiveBackendVersion();

  if (!live) {
    return { kind: 'unreachable', required, forceMatch };
  }

  if (versionsCoincide(required, live)) {
    return { kind: 'ok', required, live };
  }

  return { kind: 'mismatch', required, live, forceMatch };
}

export function isSoftDismissed(required: string, live: string): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  try {
    return sessionStorage.getItem(DISMISS_KEY) === `${required}|${live}`;
  } catch {
    return false;
  }
}

export function dismissSoftPrompt(required: string, live: string): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(DISMISS_KEY, `${required}|${live}`);
  } catch {
    // ignore
  }
}
